import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const EMPTY = { name: "", adresse: "", code_postal: "", ville: "", telephone: "", email: "", horaires: "", public: false, is_siege: false };

export function SiteInfoDialog({ open, site, onClose, onSave }) {
  const [form, setForm] = useState(EMPTY);
  useEffect(() => {
    if (open) setForm(site ? { ...EMPTY, ...Object.fromEntries(Object.keys(EMPTY).map((k) => [k, site[k] ?? EMPTY[k]])) } : EMPTY);
  }, [open, site]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-lg" data-testid="site-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-black">{site ? "Modifier l'établissement" : "Nouvel établissement"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <Field label="Nom de l'établissement *"><Input value={form.name} onChange={set("name")} data-testid="site-name" placeholder="Agence de Lyon, Camping du Lac…" /></Field>
          <Field label="Adresse"><Input value={form.adresse} onChange={set("adresse")} data-testid="site-adresse" /></Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Code postal"><Input value={form.code_postal} onChange={set("code_postal")} data-testid="site-cp" /></Field>
            <Field label="Ville"><Input value={form.ville} onChange={set("ville")} data-testid="site-ville" /></Field>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Téléphone"><Input value={form.telephone} onChange={set("telephone")} data-testid="site-tel" /></Field>
            <Field label="Email"><Input type="email" value={form.email} onChange={set("email")} data-testid="site-email" /></Field>
          </div>
          <Field label="Horaires (texte libre)"><Input value={form.horaires} onChange={set("horaires")} data-testid="site-horaires" placeholder="Lun–Ven 9h–18h, Sam 9h–12h" /></Field>
          <div className="grid grid-cols-2 gap-3 pt-1">
            <Toggle label="Siège social" hint="Un seul siège par entreprise" checked={form.is_siege} onChange={(v) => setForm({ ...form, is_siege: v })} testid="site-is-siege" />
            <Toggle label="Visible sur le mini-site" hint="Affiché dans « Nos établissements »" checked={form.public} onChange={(v) => setForm({ ...form, public: v })} testid="site-public" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annuler</Button>
          <Button onClick={() => onSave(form)} disabled={!form.name.trim()} data-testid="site-save" className="bg-[#002FA7] hover:bg-[#002175] text-white">
            {site ? "Enregistrer" : "Créer l'établissement"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

function Field({ label, children }) {
  return <div className="space-y-1.5"><Label className="text-[10px] uppercase tracking-[0.2em] font-semibold">{label}</Label>{children}</div>;
}

function Toggle({ label, hint, checked, onChange, testid }) {
  return (
    <div className="flex items-start justify-between gap-2 border border-[#DEE2E6] p-3">
      <div><div className="text-xs font-semibold">{label}</div><div className="text-[10px] text-[#868E96]">{hint}</div></div>
      <Switch checked={checked} onCheckedChange={onChange} data-testid={testid} />
    </div>
  );
}
